import { Identify, identify, init } from "@amplitude/analytics-browser";
import { useAtomValue } from "jotai";
import { useQuery } from "react-query";

import { serverSessionAtom } from "atoms/serverSession";

export const useInitialiseEventTracking = () => {
  const session = useAtomValue(serverSessionAtom);

  useQuery(
    "initialiseAmplitude",
    () =>
      init(window.__RUNTIME_ENV__.AMPLITUDE_API_KEY, session?.id, {
        disableCookies: true,
        trackingOptions: {
          ipAddress: false,
        },
        attribution: {
          trackPageViews: true,
        },
      }).promise,
    {
      enabled: !!window?.__RUNTIME_ENV__?.AMPLITUDE_API_KEY,
      onSuccess: () => {
        if (session) {
          const identifyObj = new Identify();
          identifyObj
            .setOnce("sessionId", session.id)
            .setOnce("clientId", session.clientId)
            .setOnce("claimId", session.claimId);
          // If no connection avoid to identify user as it throws error in RUM
          if (navigator.onLine) {
            identify(identifyObj);
          }
        }
      },
    }
  );
};
